import React, { useEffect, useRef } from 'react';
import { Capacitor } from '@capacitor/core';
import { AD_SLOTS, adsenseService, hasConfiguredAdSlot, type AdFormat } from '../utils/adsense';

interface AdBannerProps {
  adSlot: string;
  format?: AdFormat;
  className?: string;
  style?: React.CSSProperties;
}

export const AdBanner: React.FC<AdBannerProps> = ({
  adSlot,
  format = 'auto',
  className = '',
  style = {},
}) => {
  const requestedRef = useRef(false);
  const isNative = Capacitor.isNativePlatform();
  const configured = hasConfiguredAdSlot(adSlot);

  useEffect(() => {
    if (isNative || !configured || requestedRef.current) return;
    requestedRef.current = true;
    adsenseService.pushAd().catch((error) => {
      requestedRef.current = false;
      console.warn('AdSense placement could not be loaded:', error);
    });
  }, [configured, isNative]);

  if (isNative || !configured) return null;

  return (
    <div className={className} style={style} aria-label="Advertisement">
      <ins
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client={adsenseService.clientId}
        data-ad-slot={adSlot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export const WEB_LAUNCHER_AD_READY = hasConfiguredAdSlot(AD_SLOTS.LAUNCHER);

export const LauncherAd: React.FC<{ className?: string }> = ({ className = '' }) => (
  <AdBanner
    adSlot={AD_SLOTS.LAUNCHER}
    format="horizontal"
    className={className}
    style={{ width: '100%', minHeight: '50px', maxHeight: '90px' }}
  />
);

export default AdBanner;
